<template>
  <!--
        作者：luoyiming
        时间：2020-06-08
        描述：超链接选择-产品
    -->
  <div class="marketing-box">
    <el-tabs v-model="activeTab">
      <el-tab-pane label="分类" name="type"></el-tab-pane>
      <el-tab-pane label="详情" name="detail"></el-tab-pane>
    </el-tabs>

    <div class="product" v-if="activeTab === 'type'">
      <!--内容-->
      <div class="product-content" v-loading="loading">
        <div class="table-wrap type-table">
          <el-cascader class="ww100"
                       ref="cascaderf"
                       v-model="categoryActive"
                       :options="categoryList"
                       :props="{ checkStrictly: true, children: 'children', value: 'id', label: 'typeName' }"
                       filterable
                       @change="changeCategory">
          </el-cascader>
        </div>
      </div>
    </div>

    <div class="product-list" v-if="activeTab === 'detail'" v-loading="loading">
      <!--搜索表单-->
      <div class="common-seach-wrap">
        <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="方案名称">
            <el-input size="small" v-model="searchForm.title" placeholder="请输入方案名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" icon="el-icon-search" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!--内容-->
      <div class="product-content">
        <div class="table-wrap setlink-product-table">
          <el-table size="mini" :data="tableData" border style="width: 100%">
            <el-table-column prop="solutionTitle" label="方案标题" min-width="140"
                             header-align="center"></el-table-column>
            <el-table-column prop="cropTxt" label="应用作物" min-width="100" header-align="center"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="periodTxt" label="防控时期" min-width="100" header-align="center"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="preventionTarget" label="防治对象" min-width="100" header-align="center"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="waterConsumption" label="容器水量" width="130px"
                             align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.waterConsumption }}{{ scope.row.unit }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80">
              <template slot-scope="scope">
                <el-button size="mini" @click="changeFunc(scope.row)">选择</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import CropSolutionApi from '@/api/cropsolution.js'

export default {
  name: 'CropSolution',
  data () {
    return {
      /*是否正在加载*/
      loading: true,
      /*tab切换选择中值*/
      activeTab: 'type',
      /*产品类别列表*/
      categoryList: [],
      /*当前选中*/
      categoryActive: [],
      /*搜索表单对象*/
      searchForm: {
        title: ''
      },
      /*产品数据表*/
      tableData: [],
      /*一页多少条*/
      pageSize: 5,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1
    }
  },
  created () {
    /*获取产品类别*/
    this.getCategory()
  },
  watch: {
    activeTab: function (n, o) {
      if (n != o) {
        this.tableData = []
        if (n == 'type') {
          this.categoryActive = []
          this.autoType(this.categoryList)
        }
        if (n == 'detail') {
          this.getData()
        }
      }
    }
  },
  methods: {
    /*获取列表*/
    getCategory () {
      let self = this
      self.loading = true
      CropSolutionApi.getCropSolutionType({}, true).then(res => {
        self.categoryList = res.data || []
        // self.categoryList.forEach((item, index) => {
        //   item.children.forEach((child, index) => {
        //     delete child.children;
        //   });
        // });
        console.log(self.categoryList)
        this.categoryActive = []
        self.autoType(self.categoryList)
        self.loading = false
      }).catch(error => {
        self.loading = false
        console.log(error)
      })
    },

    /*自动选择类别*/
    autoType (list = []) {
      console.log('list', list)
      if (list.length > 0) {
        let item = list[0]
        this.categoryActive.push(item.id)
        if (item.children && typeof item.children != 'undefined' && item.children.length > 0) {
          this.autoType(item.children)
        } else {
          this.changeFunc(item)
        }
      }
    },

    /*选择类别*/
    changeCategory (e) {
      this.$nextTick(e => {
        let item = this.$refs['cascaderf'].getCheckedNodes()
        this.changeFunc(item[0].data)
      })
    },

    /*选择第几页*/
    handleCurrentChange (val) {
      let self = this
      self.curPage = val
      self.getData()
    },

    /*每页多少条*/
    handleSizeChange (val) {
      this.pageSize = val
      this.curPage = 0
      this.getData()
    },

    /*获取列表*/
    getData () {
      let self = this
      self.loading = true
      let Params = {}
      Params.pageIndex = self.curPage
      Params.pageSize = self.pageSize
      Params.title = self.searchForm.title
      CropSolutionApi.cropSolutionList(Params, true)
        .then(res => {
          self.loading = false
          self.tableData = res.data.records
          self.totalDataNumber = res.data.total
          if (self.curPage == 1 && self.tableData.length > 0) {
            self.changeFunc(self.tableData[0])
          }
        })
        .catch(error => {
          self.loading = false
        })
    },

    /*搜索查询*/
    onSubmit () {
      this.curPage = 0
      this.getData()
    },

    /*选中的值*/
    changeFunc (e) {
      let obj = {}
      if (this.activeTab == 'type') {
        obj.name = e.typeName
        obj.url = 'pages/solution/list/list?categoryId=' + e.id
        obj.type = '方案分类'
      }
      if (this.activeTab == 'detail') {
        obj.name = e.solutionTitle
        obj.url = 'pages/solution/detail/detail?solutionId=' + e.id
        obj.type = '方案详情'
      }

      this.$emit('changeData', obj)
    }


  }
}
</script>
<style scoped>
.table-wrap.setlink-product-table .product-info .pic {
  width: 20px;
  height: 20px;
  background: #FFFFFF;
}

.table-wrap.setlink-product-table .product-info .pic img {
  width: 20px;
  height: 20px;
}

.marketing-box .el-tree-node__content {
  height: 30px;
}

.marketing-box .el-tree-node__content {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/setlink/part/CropSolution.vue